/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const kitchen = {
  /**
   *  AJAX-搜索中央厨房列表
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listKitchens(keys,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_KITCHENS,
      {
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除中央厨房
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteKitchen(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_KITCHEN,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-启用/停用中央厨房
   * @param id
   * @param flag
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stopKitchen(id, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP_KITCHEN,
      {
        id: id,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加中央厨房
   *  @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD,
      {
        kitchenName : info.name,
        kitchenNum : info.num,
        contactName : info.contactName,
        mobileNo : info.mobileNo,
        kitchenAddress : info.address
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改中央厨房
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY,
      {
        kitchenName : info.name,
        kitchenNum : info.num,
        contactName : info.contactName,
        mobileNo : info.mobileNo,
        kitchenAddress : info.address,
        dcId: info.dcId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取中央厨房详情
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquire(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

}

export default kitchen;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-kitchen.js